import React from 'react'
import {Row, Col} from 'reactstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import _ from 'lodash'

import ProjectBudgetChart from './ProjectBudgetChart'
import ProjectTimeByUser from './ProjectTimeByUser'
import ProjectRecentUserActivityChart from './ProjectRecentUserActivityChart'
import ClientNameLabel from "./client/ClientNameLabel";
import AddressLabel from "./address/AddressLabel";
import ProjectFinancialSummary from "./project/ProjectFinancialSummary";

/*
{mostActiveUser ?
                            <Col className="d-flex align-items-center flex-column">
                                <ProjectRecentUserActivityChart/>
                                <p className="lead">
                                    Timesheet activity in last 7 days
                                </p>
                            </Col>
                        :

                        <Col className="d-flex align-items-center flex-column justify-content-center">
                            <h1>No Timesheets</h1>
                            <p className="lead">
                                This project has no timesheets
                            </p>
                        </Col>

                    }
 */

const ProjectSummaryBar = (props) => {

    const mostActiveUser = _.maxBy(props.project.users_time_on_project, 'total_minutes_worked')

    return (

        <Row {...props}>

            <Col>
                <Row className="mb-5">
                    <Col className="d-flex align-items-center flex-row">
                        <h1 className="m-0 mr-4">{props.project_id}</h1>
                        <div className="d-flex align-items-center justify-content-center flex-row">
                            <div className="d-flex align-items-start justify-content-center flex-column">
                                {props.clients.map(client => <ClientNameLabel key={client.client_id} {...client}/>)}
                            </div>
                            <div className="d-flex align-items-start justify-content-center flex-column">
                                {props.addresses.map(({address_id, full_address}) => (
                                    <AddressLabel key={address_id} address={full_address}/>
                                ))}
                            </div>
                        </div>

                    </Col>
                </Row>
                <Row>

                    <Col className="d-flex align-items-center flex-column">
                        {props.budgets && props.budgets.length && props.total_budget ?
                            <div className="d-flex flex-column justify-content-center" style={{flex: 1, width: '100%'}}>
                                <div className="d-flex flex-row">
                                    <div className="d-flex flex-column align-items-center justify-items-center" style={{flex: 1}}>
                                        <h1>
                                            {(((props.total_fees + props.total_supplier_invoiced) / props.total_budget) * 100).toFixed(2)}% 
                                        </h1>
                                        <p className="lead">
                                            of the budget used
                                        </p>
                                    </div>
                                    <div className="d-flex flex-column align-items-center justify-items-center" style={{flex: 1}}>
                                        <h1>
                                            {(props.project.percent_budget_used * 100).toFixed(2)}%
                                        </h1>
                                        <p className="lead">
                                            of the budget invoiced
                                        </p>
                                    </div>
                                </div>
                            
                            </div> :
                            <div className="d-flex align-items-center flex-column">
                                <h1>No Budget</h1>
                                <p className="lead">
                                    This project has no budget
                                </p>
                            </div>}

                    </Col>

                    {mostActiveUser ?
                            <Col className="d-flex align-items-center flex-column justify-content-center">
                                <ProjectTimeByUser
                                    usersTime={props.project.users_time_on_project}
                                />
                                <p className="lead">
                                    {mostActiveUser ? `${mostActiveUser.first_name} ${mostActiveUser.last_name} is most active user` : ''}
                                </p>
                            </Col> :

                        null}

                    {props.canViewFinancialSummary &&

                    <Col className="d-flex align-items-center justify-content-center">
                        <ProjectFinancialSummary {...props.project}/>
                    </Col>}


                </Row>
            </Col>
        </Row>
    )
}

ProjectSummaryBar.propTypes = {
    project_id: PropTypes.string.isRequired,
    clients: PropTypes.array,
    addresses: PropTypes.array,
    budgets: PropTypes.array,
    total_budget: PropTypes.number,
    total_fees: PropTypes.number,
    project: PropTypes.object,
    canViewFinancialSummary: PropTypes.bool
}

export default ProjectSummaryBar